import React, { useState, useEffect, useRef, useContext } from "react";
import Config from "../../Config";
import swal from "sweetalert";
import {
  withRouter,
  useHistory,
  Redirect,
  useLocation,
} from "react-router-dom";
import { PageSettings } from "../../config/page-settings";
import {
  getSystemPackageDetails,
  getPaymetStatusDetails,

} from "../../api/apiCustomPackagepayment";
import {
  CheckUserIslock
} from "../../api/apiuser.js";
import { GetPackageDetailWithCurrencyListBySuperadmin, IsCheckUserPackageUpgradeOrNot, getUsrActivePackageDetailByuserid } from "../../api/packageApi";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
import { razorPayment } from "../../api/razorpayapi";

const loadRazorpayScript = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve();
    script.onerror = () => reject('Razorpay script failed to load');
    document.body.appendChild(script);
  });
};

function CustomPackagepayment() {
  let history = useHistory();
  const location = useLocation().search;
  const context = useContext(PageSettings);
  const mapId = new URLSearchParams(location).get("CustomMapID");
  const CustomPriceID = new URLSearchParams(location).get("CustomPID");

  const [PaymetStatusloading, setisPaymetStatusLoading] = React.useState(false);
  const [loading, setisLoading] = React.useState(false);
  const [totalPrice, settotalPrice] = React.useState("");

  const [isPaymentshow, setisPaymentshow] = useState(false);

  const [isMonthly, setisMonthly] = useState(true);
  const [isYearly, setisYearly] = useState(false);
  const [autorenewal, setautorenewal] = useState(true);

  const [paymetStatusDetails, setPaymetStatusDetails] = useState(null);
  const [systemPackageDetails, setSystemPackageDetails] = useState(null);
  const [AssignCurrencyPricelist, setAssignCurrencyPricelist] = useState([]);
  const [AssignCurrencyPriceID, setAssignCurrencyPriceID] = useState("");
  const [CurrencyPriceError, setCurrencyPriceError] = useState("");
  const [isPackageDetailShow, setisPackageDetailShow] = React.useState(false);
  const [PackageDetailitem, setPackageDetailitem] = React.useState(null);
  const [CurrencyPricelist, setCurrencyPricelist] = useState([]);
  const [UserPackageInfo, setUserPackageInfo] = useState(null);

  const [isstripePay, setisstripePay] = useState('Stripepay');
  const [isRazorAvailable, setIsRazorAvailable] = useState(false);

  useEffect(() => {
    context.handleSetPageSidebar(false);
    context.handleSetPageHeader(false);
    context.handleSetPageContentFullWidth(true);
    return () => {
      context.handleSetPageSidebar(true);
      context.handleSetPageHeader(true);
      context.handleSetPageContentFullWidth(false);
    };
  }, []);
  useEffect(() => {
    GetPaymetStatusDetails(mapId);
  }, [mapId]);


  const GetPaymetStatusDetails = async (mapID) => {
    document.body.style.overflow = "hidden";
    setisPaymetStatusLoading(true);
    let response = await getPaymetStatusDetails(mapID);
    if (response) {
      if (response?.systemPackageID) {
        setisPaymetStatusLoading(false);
        setPaymetStatusDetails(response);
        document.body.style.overflow = "auto";
        let userid = response?.userID;
        GetSyatemPackageDetails(response?.systemPackageID, userid);

      } else {
        setPaymetStatusDetails(null);
        setSystemPackageDetails(null);
        setisPaymetStatusLoading(false);
        setisPackageDetailShow(false);
        setPackageDetailitem(null);
        setCurrencyPricelist([]);
        setUserPackageInfo(null)
        document.body.style.overflow = "auto";
        swal("Sorry! this link is not available please contact administrator", {
          icon: "warning",
        });
      }
    } else {
      setisPackageDetailShow(false);
      setPackageDetailitem(null);
      setUserPackageInfo(null)
      setCurrencyPricelist([]);
      swal("Sorry! this link is not available please contact administrator", {
        icon: "warning",
      });
    }
  };


  const GetSyatemPackageDetails = async (SID, userid) => {
    document.body.style.overflow = "hidden";
    setisLoading(true);
    let data = await getUsrActivePackageDetailByuserid(userid);
    if (data != null && data?._id !== null && data?._id !== "" && data?._id !== undefined) {
      console.log("GetUserPackage===>", data)
      setUserPackageInfo(data)
    }
    // let response = await getSystemPackageDetails(SID);
    let response = await GetPackageDetailWithCurrencyListBySuperadmin(SID);
    if (response) {
      if (response?._id) {
        setisLoading(false);
        setSystemPackageDetails(response);
        if (data != null && data?._id !== null && data?._id !== "" && data?._id !== undefined && data?.isActive) {
          const currencylist = response?.currencyList;
          let ActivePackagecurrencyID = data?.currencyID;
          if (ActivePackagecurrencyID && currencylist.length > 0) {
            const Activecurrency = currencylist.filter(x => x.currencyID === ActivePackagecurrencyID);
            if (Activecurrency) {
              setAssignCurrencyPricelist(Activecurrency);
              //setAssignCurrencyPriceID(Activecurrency[0]?.value)
              // setcurrency(Activecurrency[0]?.value)
            }
            else {
              setAssignCurrencyPricelist([]);
              setAssignCurrencyPriceID("")
            }
          }
        }
        else {
          setAssignCurrencyPricelist(response?.currencyList);
          //setAssignCurrencyPriceID(CustomPriceID);
        }
        // setAssignCurrencyPricelist(response?.currencyList);
        setisPackageDetailShow(true);
        setPackageDetailitem(response);
        // setCurrencyPricelist(response?.currencyList)
      } else {
        setisPackageDetailShow(false);
        setPackageDetailitem(null);
        // setCurrencyPricelist([]);
        setAssignCurrencyPricelist([]);
        document.body.style.overflow = "auto";
        setisLoading(false);
        setPaymetStatusDetails(null);
        setSystemPackageDetails(null);
        swal("Sorry! please contact administrator", {
          icon: "error",
        });
      }
    } else {
      setisPackageDetailShow(false);
      setPackageDetailitem(null);
      setAssignCurrencyPricelist([]);
      // setCurrencyPricelist([]);
      swal("Sorry! please contact administrator", {
        icon: "error",
      });
    }
  };
  const Proceedpackage = async () => {
    if (systemPackageDetails !== null && systemPackageDetails !== undefined) {
      if (
        AssignCurrencyPriceID !== null &&
        AssignCurrencyPriceID !== "" &&
        AssignCurrencyPriceID !== undefined
      ) {
        let selectCurrencyitem = AssignCurrencyPricelist.find(
          (x) => x.value === AssignCurrencyPriceID
        );
        if (selectCurrencyitem !== null) {
          settotalPrice(
            selectCurrencyitem?.otherName + " " + selectCurrencyitem?.priceValue
          );
        } else {
          return true;
        }
      } else {
        setCurrencyPriceError("please select package price");
        return true;
      }
      //setisPaymentshow(true);
      if (systemPackageDetails?._id && paymetStatusDetails?.userID) {
        let ischeckupdateornot = await IsCheckUserPackageUpgradeOrNot(systemPackageDetails?._id, paymetStatusDetails?.userID, AssignCurrencyPriceID, isstripePay);
        if (ischeckupdateornot === true) {
          setisPaymentshow(true);
        }
        else {
          swal("Please adjust your current package with your previous one. Click this link to review and make the necessary adjustments.");
        }
      }


      // if (isMonthly === true) {
      //   settotalPrice(systemPackageDetails?.monthlyPrice);
      // } else {
      //   settotalPrice(systemPackageDetails?.annuallyPrice);
      // }


    }
  };
  const handlePaymentSuccess = (response) => {
    console.log("Payment response:", response);
    const razorpay_payment_id = response.razorpay_payment_id;
    const razorpay_order_id = response.razorpay_subscription_id;
    const razorpay_signature = response.razorpay_signature;
    if (razorpay_payment_id) {
      swal("Your package has been successfully updated 30 minutes ago.");
    }
  };
  const onSubmitRazorpay = async () => {
    try {
      let checkLogin = localStorage.getItem("loginUserID");
      let retvalbody = {
        "userCompanyID": checkLogin,
        "systemPackagePriceUniqueGuid": AssignCurrencyPriceID,
        "isautorenewal": autorenewal,
        "packageID": systemPackageDetails?._id,
        "createdBy": "",
      }

      const res = await razorPayment(JSON.stringify(retvalbody));
      if (res?._id && res?.subscriptionId) {
        await loadRazorpayScript();
        const options = {
          key: Config.razorpaypublishablekey,
          subscription_id: res?.subscriptionId,
          name: "Your Company Name",
          description: "Subscription Payment",
          handler: function (response) {
            handlePaymentSuccess(response)
          },
          theme: {
            color: "#3399cc",
          },
        };
        const razorpay = new window.Razorpay(options);
        razorpay.open();
      }
      else {
        swal("Error", + res);
      }
    } catch (err) {
      swal("Error!", err?.message, "error");
    }
  }

  const onSubmit = async () => {
    let checkLogin = localStorage.getItem("loginUserID");
    var userid = paymetStatusDetails?.userID;
    if (userid != null && userid !== "") {
      let retval = {
        "userID": userid,
        "packagePriceID": AssignCurrencyPriceID,
        "isautorenewal": autorenewal,
        "packageID": systemPackageDetails?._id,
      }
      fetch(Config.apiUrl +
        "create-checkout-session/Create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(retval),
        },

      ).then((response) => {
        if (response?.status === 401) {
        }
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
        .then((responseJson) => {
          if (responseJson?.responseUrl !== null && responseJson?.responseUrl !== "" && responseJson?.responseUrl !== undefined && responseJson?.responseType !== 'Error') {
            window.location.replace(responseJson?.responseUrl)
          }
          else {
            swal(responseJson.message);
          }
        })
        .catch((error) => {
          swal("Error", + error);
        });
    }

  };
  const bytesToSize = (bytes) => {
    if (bytes !== null && bytes !== "" && bytes !== undefined) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return 0;
      // var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)));
      if (i == 0) return bytes + " " + sizes[i];
      return (bytes / Math.pow(1000, i)).toFixed(0) + " " + sizes[i];
    } else {
      return "N/A";
    }
  };
  return (
    // <div className="body_new">
    //   <div className="App_new">
    //     <div className="container_new">
    //       <h1>
    //         <br />
    //         Coming Soon
    //       </h1>
    //     </div>
    //   </div>
    <>
      <LoaderSpinner isrefresh={loading} />
      <div className=""></div>
      <div className="custom-package">
        <div className="right-content">
          <div className="login-content">
            <ol className="breadcrumb float-xl-right">
              <li className="breadcrumb-item">
                <a href="./login">Home</a>
              </li>
              <li className="breadcrumb-item active">Packages and billing</li>
            </ol>
            <h1 className="page-header">Packages and billing</h1>
          </div>
          {paymetStatusDetails && systemPackageDetails ? (
            <>
              <div className="form-group row m-b-10 flex-wrap">
                <label className="col-md-4 col-form-label" htmlFor="autorenewal">
                  Your subscribed package
                </label>
                <div className="searchForm col-md-8">
                  {systemPackageDetails?.packageName
                    ? systemPackageDetails?.packageName
                    : "N/A"}
                </div>
                <label className="col-md-4 col-form-label" htmlFor="autorenewal">
                  Your package
                </label>
                <div className="searchForm col-md-8">
                  {systemPackageDetails?.isMonthly === false
                    ? "Yearly"
                    : "Monthly"}
                </div>
                <label
                  className="col-md-4 col-form-label"
                // htmlFor="autorenewal"
                >
                  Package Price
                </label>
                <div className="searchForm col-md-8">
                  <select
                    disabled={isPaymentshow}
                    className="default-select2 form-control w-25"
                    onChange={(e) => {
                      setCurrencyPriceError("");
                      setAssignCurrencyPriceID(e.target.value);
                      const item = AssignCurrencyPricelist.find(x => x.value == e.target.value);
                      setIsRazorAvailable(item?.isRazorPayAvailable ? item?.isRazorPayAvailable : false);
                      if (item?.isRazorPayAvailable == true) {
                        setisstripePay("Razorpay");
                      }
                      else {
                        setisstripePay('Stripepay')
                      }

                    }}
                  >
                    <option value={""} selected={AssignCurrencyPriceID === ""}>
                      {"--- select package price ---"}
                    </option>
                    {AssignCurrencyPricelist?.map((item) => {
                      return (
                        <option
                          value={item?.value}
                          selected={AssignCurrencyPriceID === item?.value}
                        >
                          {item?.label} {item?.otherName} {item?.priceValue}
                        </option>
                      );
                    })}
                  </select>
                  {CurrencyPriceError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {CurrencyPriceError}
                    </span>
                  )}
                </div>
                <label className="col-md-4 col-form-label">
                  Your subscribed package auto renewal
                </label>
                <div className="searchForm col-md-8 ">
                  <input
                    type="checkbox"
                    value=""
                    disabled={isPaymentshow}
                    id="autorenewal"
                    checked={autorenewal}
                    onChange={(e) => {
                      setautorenewal(!autorenewal);
                    }}
                  />
                </div>

                <label className="col-md-4 col-form-label">
                  Payment Type
                </label>
                <div className="searchForm col-md-8 mt-2">
                  <dev className="col-md-6 col-form-label">
                    <input
                      type="radio"
                      checked={isstripePay === "Stripepay" ? true : false}
                      //disabled={isPaymentshow}
                      disabled={isPaymentshow || isRazorAvailable}
                      onChange={() => {
                        if (!isPaymentshow) {
                          setisstripePay('Stripepay')
                        }
                      }}
                    />
                    <label className="mr-2 ml-2">
                      Stripe Pay {"(International)"}
                    </label>
                  </dev>
                  <dev className="col-md-6 col-form-label">
                    <input
                      type="radio"
                      checked={isstripePay === "Razorpay" ? true : false}
                      disabled={isPaymentshow || !isRazorAvailable}
                      onChange={() => {
                        if (!isPaymentshow && isRazorAvailable) {
                          setisstripePay("Razorpay")
                        }
                      }}
                    />
                    <label className="mr-2 ml-2">
                      Razor Pay {"(Indian, UPI, QR Code, Credit Card, Debit & Others)"}
                    </label>
                  </dev>

                </div>


              </div>
              <div className="form-group row m-b-10 flex-wrap mt-4">
                <div className="my-2  my-xl-0 ml-md-2">
                  {isPaymentshow ? (
                    <>

                      {
                        isstripePay === "Stripepay" ?
                          <button
                            type="button"
                            className="btn  btn-primary m-r-5 shadow-add"
                            onClick={async () => {
                              let checkLogin = localStorage.getItem("loginUserID");
                              if (checkLogin) {
                                const checkuserlock = await CheckUserIslock(checkLogin);
                                if (checkuserlock === false || checkuserlock === false) {
                                  swal(
                                    "oops!",
                                    "Sorry! You can not do any transaction in 1 hour.",
                                    "warning"
                                  );
                                }
                                else {
                                  onSubmit();
                                }
                              }
                            }}
                          >
                            {`Stripe Pay ${totalPrice ? totalPrice : 0}`}
                          </button>
                          : isstripePay === "Razorpay" ? <button
                            type="button"
                            className="btn  btn-primary m-r-5 shadow-add"
                            onClick={async () => {
                              let checkLogin = localStorage.getItem("loginUserID");
                              if (checkLogin) {
                                const checkuserlock = await CheckUserIslock(checkLogin);
                                if (checkuserlock === false || checkuserlock === false) {
                                  swal(
                                    "oops!",
                                    "Sorry! You can not do any transaction in 1 hour.",
                                    "warning"
                                  );
                                }
                                else {
                                  onSubmitRazorpay();
                                }
                              }
                            }}
                          >
                            {`Razor Pay ${totalPrice ? totalPrice : 0}`}
                          </button>
                            : <></>
                      }
                    </>
                    // <button
                    //   type="button"
                    //   className="btn  btn-primary m-r-5 shadow-add"

                    //   onClick={async () => {
                    //     let checkLogin = paymetStatusDetails?.userID;
                    //     if (checkLogin) {
                    //       const checkuserlock = await CheckUserIslock(checkLogin);
                    //       if (checkuserlock === false || checkuserlock === false) {
                    //         swal(
                    //           "oops!",
                    //           "Sorry! You can not do any transaction in 1 hour.",
                    //           "warning"
                    //         );
                    //       }
                    //       else {
                    //         onSubmit();
                    //       }
                    //     }
                    //   }}
                    // >
                    //   {"Pay (" + totalPrice + " )"}
                    // </button>
                  ) : (
                    <button
                      type="button"
                      className="btn  btn-primary m-r-5 shadow-add"
                      onClick={async () => {
                        let checkLogin = paymetStatusDetails?.userID;
                        if (checkLogin) {
                          const checkuserlock = await CheckUserIslock(checkLogin);
                          if (checkuserlock === false || checkuserlock === false) {
                            swal(
                              "oops!",
                              "Sorry! You can not do any transaction in 1 hour.",
                              "warning"
                            );
                          }
                          else {
                            Proceedpackage();
                          }
                        }
                      }}
                    >
                      Proceed
                    </button>
                  )}
                </div>

                {isPaymentshow === false ? (
                  <div className="my-2  my-xl-0 ml-md-2">
                    <button
                      type="button"
                      className="btn  btn-danger m-r-5 shadow-add"
                      onClick={() => {
                        history.push("/Login");
                      }}
                    >
                      Go To Login
                    </button>
                  </div>
                ) : (
                  <div className="my-2  my-xl-0 ml-md-2">
                    <button
                      type="button"
                      className="btn  btn-danger m-r-5 shadow-add"
                      onClick={() => {
                        setisPaymentshow(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="my-2  my-xl-0 ml-md-2">
              <button
                type="button"
                className="btn  btn-danger m-r-5 shadow-add"
                onClick={() => {
                  history.push("/Login");
                }}
              >
                Go To Login
              </button>
            </div>
          )}
        </div>
        {
          isPackageDetailShow ? <>
            <h5>Package Detail </h5>

            <div class="px-4 py-3 rounded">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-6">
                  <div>
                    <div class="d-flex justify-content-between align-items-center">
                      <p class="help-text-simple">
                        <b>
                          {" "}
                          <img
                            src="assets/img/tick-mark-icon-png-7.png"
                            height="24"
                          />
                        </b>
                        {" "}

                        <b>{(PackageDetailitem?.apDynamicQrCodeCount === -1 || PackageDetailitem?.apDynamicQrCodeCount === "-1") ? "Unlimited" : PackageDetailitem?.apDynamicQrCodeCount}</b> &nbsp; QR Code Count
                      </p>
                    </div>
                  </div>

                  <div>
                    <div class="d-flex justify-content-between align-items-center">
                      <p class="help-text-simple">
                        <b>
                          {" "}
                          <img
                            src="assets/img/tick-mark-icon-png-7.png"
                            height="24"
                          />
                        </b>
                        {" "}

                        <b>{(PackageDetailitem?.dataStorageCount === -1 || PackageDetailitem?.dataStorageCount === "-1") ? "Unlimited" : bytesToSize(PackageDetailitem?.dataStorageCount)}</b> &nbsp; Data storage limit
                      </p>
                    </div>
                  </div>
                  {
                    PackageDetailitem?.isWeb === true && (
                      <>
                        <div>
                          <div class="d-flex justify-content-between align-items-center">
                            <p class="help-text-simple">
                              <b>
                                {" "}
                                <img
                                  src="assets/img/tick-mark-icon-png-7.png"
                                  height="24"
                                />
                              </b>
                              {" "}

                              <b>{(PackageDetailitem?.monthlyScanCount === -1 || PackageDetailitem?.monthlyScanCount === "-1") ? "Unlimited" : PackageDetailitem?.monthlyScanCount}</b> &nbsp;Monthly scans
                            </p>
                          </div>
                        </div>

                        <div>
                          <div class="d-flex justify-content-between align-items-center">
                            <p class="help-text-simple">
                              <b>
                                {" "}
                                <img
                                  src="assets/img/tick-mark-icon-png-7.png"
                                  height="24"
                                />
                              </b>
                              {" "}

                              <b>{(PackageDetailitem?.noOfChatUser === -1 || PackageDetailitem?.noOfChatUser === "-1") ? "Unlimited" : PackageDetailitem?.noOfChatUser}</b>&nbsp; Number of Email Messages{" "}
                            </p>
                          </div>
                        </div>
                      </>)
                  }
                  {PackageDetailitem?.isYourBranding ?
                    <div>
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="help-text-simple">
                          <b>
                            {" "}
                            <img
                              src="assets/img/tick-mark-icon-png-7.png"
                              height="24"
                            />
                          </b>
                          &nbsp;Your branding{" "}
                        </p>
                      </div>
                    </div>
                    : <></>
                  }
                </div>
                <div className="col-md-6 col-sm-6 col-6">
                  {PackageDetailitem?.isChatEnabled ?
                    <div>
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="help-text-simple">
                          <b>
                            {" "}
                            <img
                              src="assets/img/tick-mark-icon-png-7.png"
                              height="24"
                            />
                          </b>
                          &nbsp; QR Code Chat Enabled{" "}
                        </p>
                      </div>
                    </div>
                    : <></>
                  }
                  {PackageDetailitem?.isSSLCertificate ?
                    <div>
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="help-text-simple">
                          <b>
                            {" "}
                            <img
                              src="assets/img/tick-mark-icon-png-7.png"
                              height="24"
                            />
                          </b>
                          &nbsp;SSL Certificate with QR Code
                        </p>
                      </div>
                    </div>
                    : <></>
                  }

                  {PackageDetailitem?.isExportQrCode ?
                    <div>
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="help-text-simple">
                          <b>
                            {" "}
                            <img
                              src="assets/img/tick-mark-icon-png-7.png"
                              height="24"
                            />
                          </b>
                          &nbsp;Export QR Code data{" "}
                        </p>
                      </div>
                    </div>
                    : <></>
                  }
                  {PackageDetailitem?.isEmailSupport ?
                    <div>
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="help-text-simple">
                          <b>
                            {" "}
                            <img
                              src="assets/img/tick-mark-icon-png-7.png"
                              height="24"
                            />
                          </b>
                          &nbsp;Email support{" "}
                        </p>
                      </div>
                    </div>
                    : <></>
                  }
                </div>
              </div>



              <div class="text-center mt-3 mb-3">
              </div>
            </div>
          </> : <></>
        }
      </div>
    </>
    // </div>

  );
}

export default CustomPackagepayment;
